export const requestStatus = () => ({
  isFinished: false,
  isProcessing: false,
  error: false,
});
